<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Office Automation</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Office Automation"
            image-url="/pages/products/industries/oa.jpg"
            :contents="[
              'Office equipment is essential for our work life. Either us or our colleagues use them every day when work in the office. Thailand is one of the biggest manufacturing bases for office equipment and we are providing plastic materials to serve customers from this market. Materials used in this equipment has good colorability, good impact for its housing as well as mechanical, electrical properties for its internal parts. We are supplying plastic resins to these applications.',
            ]"
            is-reverse="true"
            is-white-content="true"
            is-content-small-text="true"
            left-width="45.805%"
            right-width="54.195%"
          />
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/c-printer.jpg" alt="Printer">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Printer</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/c-copy.jpg" alt="Copy machine">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Copy machine</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/c-cons.jpg" alt="Conference equipment">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Conference equipment</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/c-projector.jpg" alt="Projector">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Projector</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/c-scanner.jpg" alt="Scanner">
                      </a>
                    </div>
                    <div class="card-content text-center">
                      <a href="#" class="card-title f-21">Scanner</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

  </section>
</template>
<script setup>
useHead({
  title:'Office Automation - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding-bottom: 85px;
}

.section-gallery {
  padding-top: 60px;
  padding-bottom: 60px;
}
</style>